import React, { useState } from 'react';
import type { InventoryItem } from '../../../../shared/CharacterTypes';
import { ITEM_DATABASE } from '../../../../shared/content/generated/items.gen';
import { boundItemLabel, isBindingBound } from '../../../../shared/inventory/itemBinding';
import { TomeButton } from '../../primitives/tome';

/**
 * Drop a bag stack on the ground (plan 23 row 42, lane BI). Two steps, so a
 * stray click never drops anything; the server decides and the bag updates
 * from its snapshot. Bound items say why they stay.
 */
export function InventoryDropControl({ item, name, drop }: {
  item: InventoryItem; name: string; drop: (item: InventoryItem, quantity: number) => void;
}): React.ReactElement | null {
  const [confirming, setConfirming] = useState(false);
  const binding = ITEM_DATABASE[item.id]?.binding;
  if (!binding) return null;
  if (isBindingBound(binding)) {
    return <p className="inventory-browser__bound" data-item-binding={binding}>{boundItemLabel(binding)}. It cannot be dropped.</p>;
  }
  if (!confirming) {
    return <TomeButton tone="quiet" className="inventory-browser__drop" onClick={() => setConfirming(true)}
      aria-label={`Drop ${name}`}>Drop…</TomeButton>;
  }
  const finish = (quantity: number) => { setConfirming(false); drop(item, quantity); };
  return <div className="inventory-browser__drop-confirm" role="group" aria-label={`Drop ${name} on the ground?`}>
    <span>Drop on the ground? Anyone can pick it up after a few seconds.</span>
    <div>
      {item.quantity > 1 && <TomeButton tone="secondary" onClick={() => finish(1)}>Drop 1</TomeButton>}
      <TomeButton tone="secondary" onClick={() => finish(item.quantity)}>
        {item.quantity > 1 ? `Drop all ×${item.quantity}` : 'Drop'}</TomeButton>
      <TomeButton tone="quiet" onClick={() => setConfirming(false)}>Keep</TomeButton>
    </div>
  </div>;
}
